<template>
    <md-table-cell>
        <slot/>
    </md-table-cell>
</template>

<script>
    export default {
        name: "IndexTableCell"
    }
</script>

<style scoped>

</style>